import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export function BookingVehicleSelection({ flow }: { flow: any }) {
  const isValid = flow.nome.length > 2 && flow.plate.length >= 7 && flow.vehicleModel.length > 1 && flow.phone.length >= 8

  return (
    <div className="space-y-4 animate-in fade-in slide-in-from-bottom-4">
      <h2 className="text-lg font-semibold">Dados do Veículo e Contato</h2>
      
      <div className="space-y-2">
        <Label>Placa do Veículo</Label>
        <Input 
          placeholder="ABC-1234" 
          value={flow.plate}
          onChange={(e) => flow.setPlate(e.target.value.toUpperCase())}
          maxLength={8}
        />
      </div>

      <div className="space-y-2">
        <Label>Modelo e Marca (Ex: Honda Civic)</Label>
        <Input 
          placeholder="Modelo do carro" 
          value={flow.vehicleModel}
          onChange={(e) => flow.setVehicleModel(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <Label>Cor (Opcional)</Label>
        <Input 
          placeholder="Preto, Prata..." 
          value={flow.vehicleColor}
          onChange={(e) => flow.setVehicleColor(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <Label>Seu Nome</Label>
        <Input 
          placeholder="Como gostaria de ser chamado?" 
          value={flow.nome}
          onChange={(e) => flow.setNome(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <Label>WhatsApp</Label>
        <Input 
          placeholder="(11) 99999-9999" 
          value={flow.phone}
          onChange={(e) => flow.setPhone(e.target.value)}
        />
      </div>

      <div className="pt-4 flex gap-2">
        <Button variant="outline" className="w-full" onClick={() => flow.setStep(1)}>
          Voltar
        </Button>
        <Button className="w-full" disabled={!isValid} onClick={() => flow.setStep(3)}>
          Avançar
        </Button>
      </div>
    </div>
  )
}
